import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const FAQ = ({ faqs = [] }) => {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-list" className="divide-y divide-border border border-border rounded-2xl overflow-hidden bg-card">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} data-testid={`faq-item-${i}`} className="px-5 sm:px-7">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`faq-toggle-${i}`}
              className="w-full flex items-center justify-between gap-4 py-5 sm:py-6 text-left focus-visible:outline-none"
              aria-expanded={isOpen}
            >
              <span className="font-display text-lg sm:text-xl uppercase tracking-[0.02em] text-foreground">{f.q}</span>
              <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border bg-background">
                {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </span>
            </button>
            {isOpen && (
              <div className="pb-6 -mt-1 pr-12 text-sm sm:text-base text-muted-foreground leading-relaxed">{f.a}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
